import { plans } from '@constants/plans'

export const checkRequiredPlan = (currentPlanLevel: number): string => {
  for (const planName in plans) {
    if (planName === 'development_mode' || planName === 'teams') {
      continue
    }
    const plan = plans[planName as keyof typeof plans]
    if (plan.level && plan.level >= Number(currentPlanLevel)) {
      return plan.name
    }
  }
  return ''
}
